export default __webpack_public_path__ + "static/media/suiteImg3.4b109be9.png";